/* eslint-disable */
import * as icon from 'vue-svgicon'
icon.register({
  'move': {
    width: 16,
    height: 16,
    viewBox: '0 0 48 48',
    data: '<path pid="0" d="M35.646 23.646l-4.293-4.293c-.194-.194-.353-.128-.353.147V22h-5v-5l2.484-.013c.275-.002.341-.162.146-.356l-4.277-4.277a.502.502 0 0 0-.707 0l-4.293 4.293c-.194.194-.128.353.147.353H22v5h-5v-2.5c0-.275-.159-.341-.354-.146l-4.293 4.293a.502.502 0 0 0 0 .707l4.293 4.293c.195.194.354.128.354-.147V26h5v5h-2.5c-.275 0-.341.159-.147.354l4.293 4.293a.502.502 0 0 0 .707 0l4.293-4.293c.195-.195.129-.354-.146-.354H26v-5h5v2.5c0 .275.159.341.353.146l4.293-4.293a.5.5 0 0 0 0-.707z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/compiled-icons/move.js